/** The path a notification click may take the app to: inside the app only (a
 * push payload comes from our server, but the worker message channel is not a
 * place to trust a URL from). */
export const pushTarget = (url: unknown): string | null =>
  typeof url === 'string' && url.startsWith('/') && !url.startsWith('//') && !/[\\\s]/.test(url) ? url : null
